import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent, Message } from 'primeng/api';
import { Table } from 'primeng/table';
import { Administradora } from 'src/app/admihair/api/dto/administradora';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Grupo } from 'src/app/admihair/api/dto/grupo';
import { PageResponse } from 'src/app/admihair/api/dto/paginacao/page-response';
import { EmpresaService } from 'src/app/admihair/service/empresa.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-empresa-listar',
  templateUrl: './empresa-listar.component.html',
  styleUrls: ['./empresa-listar.component.scss']
})
export class EmpresaListarComponent implements OnInit {

  constructor(private empresaService: EmpresaService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute) { }

  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  loading: boolean = false;
  loadingEmpresas: boolean = false;
  grupos: Grupo[] = [];
  franquia?: Administradora = this.utilStorageService.getAdministradora();

  inputBusca: string = '';
  ordenacao: string = "nomeFantasia,ASC";
  numeroPagina: number = 0;
  tamanhoPagina: number = 10;

  itensPaginados: PageResponse<Empresa> = {
    content: [],
    number: 0,
    size: 0,
    totalElements: 0,
    totalPages: 0,
    last: false
  }
  

  @ViewChild('filter') filter!: ElementRef;

  ngOnInit(): void {
  }

  onLazyLoad(event: LazyLoadEvent) {
    
      if (event.first !== undefined && event.rows !== undefined) {
        if (event.first === 0 && event.rows === 0) {
          this.numeroPagina = 0;
        } else {
          this.numeroPagina = event.first / event.rows;
        }
      }
      if (event.rows) {
        this.tamanhoPagina = event.rows;
      }
      this.definirOrdenacao(event.sortField, event.sortOrder);
      this.listarEmpresas();
    }
  
    definirOrdenacao(sortField?: string, sortOrder?: number) {
      const campoDeOrdenacao = sortField ? sortField : "nomeFantasia";
      const direcaoOrdenacao = sortOrder === -1 ? "DESC" : "ASC";
      this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
    }

  listarEmpresas(){
    this.loading = true;
    this.empresaService.listarEmpresasPorFranquiaPaginado(
      this.franquia?.id,
      this.numeroPagina,
      this.tamanhoPagina,
      this.ordenacao,
      this.inputBusca
    ).subscribe({
        next: (data: PageResponse<Empresa>) => {
          this.itensPaginados = data;
          this.loading = false;
        },
        error: (err: any) => {
          this.loading = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      });
  }

  buscar(event: Event) {
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.listarEmpresas();
  }

  limpar(table: Table) {
    this.inputBusca = "";
    table.rows = 10;
    this.filter.nativeElement.value = '';
    table.clear();
  }

  detalhar(id: number) {
    this._router.navigate(["/rfarias/empresa/detalhar/" + id], { relativeTo: this._activatedRoute })
  }

  editar(id: number) {
    this._router.navigate(["/rfarias/empresa/editar/" + id], { relativeTo: this._activatedRoute })
  }

}
